import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FadeUp } from "./Reveal";
import { api } from "../lib/api";
import ShareFragment from "./ShareFragment";

export default function DailyFragment() {
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    let tries = 0;
    let timer;
    const load = () => api.get("/fragment/today").then((r) => {
      setDoc(r.data?.fragment ?? null);
      if (!r.data?.is_today && tries++ < 4) timer = setTimeout(load, 15000);
    }).catch(() => setDoc(null));
    load();
    return () => clearTimeout(timer);
  }, []);

  if (!doc?.fragment) return null;
  const date = new Date(`${doc.day}T12:00:00Z`).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });

  return (
    <section className="px-5 sm:px-8 lg:px-12 py-20 lg:py-28 border-t border-[var(--line)]" data-testid="daily-fragment">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-3">
          <p className="eyebrow">&sect; Fragment of the day</p>
          <p className="f-mono text-xs text-[var(--ash)] mt-3" data-testid="daily-fragment-date">{date}</p>
        </div>
        <FadeUp className="lg:col-span-9">
          <p className="f-serif italic font-light text-3xl sm:text-5xl leading-[1.12] tracking-tight" data-testid="daily-fragment-text">{doc.fragment}</p>
          {doc.headline && (
            <p className="mt-8 f-mono text-xs text-[var(--ash)] flex flex-wrap items-center gap-2" data-testid="daily-fragment-headline">
              <span className="w-2 h-2 rounded-full bg-[var(--signal)]" /> Cut from the headline: <span className="text-[#cfcec8] normal-case">{doc.headline}</span>
              {doc.source?.url && <a href={doc.source.url} target="_blank" rel="noopener noreferrer" className="link-u text-[var(--bone)] inline-flex items-center gap-1" data-testid="daily-fragment-source">source <ArrowUpRight size={12} /></a>}
            </p>
          )}
          <p className="f-mono text-[11px] text-[var(--ash)] mt-3">AI-written from that day's news via Perplexity</p>
          <div className="flex flex-wrap gap-x-8 gap-y-4 mt-8">
            <Link to="/fragments" className="inline-flex items-center gap-2 f-mono text-xs uppercase tracking-[0.2em] link-u" data-testid="daily-fragment-archive-link">Every fragment so far <ArrowUpRight size={14} /></Link>
            <ShareFragment fragment={doc} />
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
